import { useRef } from 'react';

const useVariable = <T>(initialValue?: T) => {
  const ref = useRef([
    initialValue,
    (param: T) => {
      ref.current[0] = typeof param === 'function' ? param(ref.current[0]) : param;
    },
  ]);
  return ref.current as [T, (param: T | ((prevCachedStates: T) => T)) => void];
};

export default useVariable;
